<template>
  <div>
  <b-table hover :items=items :fields=fields responsive>

    <!-- title -->
    <template v-slot:cell(competition)="row">
      <b-button :to="row.item.route" variant="primary" size="sm" class="w-100">
        {{ row.item.competition.title() }}
      </b-button>
    </template>

    <template v-slot:cell(registrations)="row">
          <span v-if="row.item.registration.registered()" v-b-tooltip.hover
                :title="row.item.registration.registrationCount + ' Schüler sind angemeldet'">
            {{ row.item.registration.registrationCount }}
          </span>
      <span v-else>-</span>
    </template>

    <template v-slot:cell(fees)="row">
          <span v-if="row.item.registration.registered()" v-b-tooltip.hover
                :title="row.item.registration.registrationCount + ' Schüler x ' + row.item.competition.costs.price + ' ' + row.item.competition.costs.currency">
            {{ row.item.registration.payment.total.short }}
          </span>
      <span v-else>-</span>
    </template>

    <template v-slot:cell(payment)="row">
      <span v-if="row.item.registration.registered() && row.item.payment.saldo.float < 0" v-b-tooltip.hover style="color: red" :title="'Bereits gezahlt: ' + row.item.payment.payed.short">
        {{ row.item.payment.saldo.short }}
      </span>

      <span v-else-if="row.item.registration.registered()" v-b-tooltip.hover :title="'Bereits gezahlt: ' + row.item.payment.payed.short">
        0
      </span>

      <span v-else>-</span>
    </template>

    <template v-slot:cell(registration)="row">
      <registration-button
          v-bind:competition="row.item.competition"
          v-bind:registration="row.item.registration">
      </registration-button>
    </template>
  </b-table>
  </div>
</template>
<script>
import RegistrationButton from '@/components/competitions/registration/Button'
export default {
  name: 'EndedCompetitionsTable',
  props: ['items'],
  components: {
    registrationButton: RegistrationButton
  },
  data: function () {
    return {
      fields: [
        {key: 'competition', label: 'Wettbewerb'},
        {key: 'registrations', label: 'Anmeldungen', class: 'text-center'},
        {key: 'fees', label: 'Teilnahmegebühren', class: 'text-center'},
        {key: 'payment', label: 'Saldo', class: 'text-center'},
        {key: 'registration', label: 'Anmeldung', class: 'text-center'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/CurrentTable.vue